if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

      // Keep references, but we won't use cart drawer rendering anymore
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton?.classList?.add('loading');
      this.querySelector('.product-form-button-text')?.classList?.add('hidden');
      document.querySelector('.sticky-atc-container .product-form-button-text')?.classList?.add('hidden');
      this.querySelector('.loading-overlay__spinner')?.classList?.remove('hidden');
      document.querySelector('.sticky-atc-container .loading-overlay__spinner')?.classList?.remove('hidden');

      var config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      var formData = new FormData(this.form);

      // We are intentionally NOT appending sections to render,
      // because we are not updating/opening the cart drawer anymore.

      this.formIdInputValue = this.form.querySelector('[name=id]').value;
      if (this.formIdInputValue.includes(',')) {
        formData.delete('id');
        formData.delete('quantity');
      }

      config.body = formData;

      // ✅ ALWAYS go to checkout after successful add
      this.skipCart = true;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          // ✅ ALWAYS redirect to checkout on success
          window.location = "/checkout";
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner')?.classList?.add('hidden');

          const stickySpinner = document.querySelector('.sticky-atc-container .loading-overlay__spinner');
          if (stickySpinner) stickySpinner.classList.add('hidden');

          // Optional: show success message briefly (it may not be seen due to redirect)
          const success = this.querySelector('.product-added-success');
          if (success) success.classList.remove('hidden');

          const stickySuccess = document.querySelector('.sticky-atc-container .product-added-success');
          if (stickySuccess) stickySuccess.classList.remove('hidden');

          setTimeout(() => {
            if (success) success.classList.add('hidden');
            if (stickySuccess) stickySuccess.classList.add('hidden');

            this.querySelector('.product-form-button-text')?.classList?.remove('hidden');
            const stickyText = document.querySelector('.sticky-atc-container .product-form-button-text');
            if (stickyText) stickyText.classList.remove('hidden');
          }, 300);
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
